import { iframeAppBiLoggerFactory } from '@wix/iframe-app-bi-logger';

const biLoggerFactory = iframeAppBiLoggerFactory(window.Wix);

export const updateBiLoggerDefaults = (defaults: Record<any, any>) => {
  biLoggerFactory.updateDefaults(defaults);
};

export const biLogger = biLoggerFactory.logger();
